/**
 * User: Joe Forzano
 * Date: 6/7/14
 * Time: 12:49 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */

(function(root, factory) {
    'use strict';

    if (typeof module !== 'undefined') {
        factory(module);
    } else {
        var _module = {
            exports: {},
        };
        factory(_module);
        root.dibsGuidGenerator = _module.exports;
    }
})(typeof window === 'undefined' ? global : window, function(module) {
    'use strict';
    var getGuidSection;

    getGuidSection = function getGuidSection() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };

    module.exports.getGuid = function getGuid() {
        return (
            getGuidSection() +
            getGuidSection() +
            '-' +
            getGuidSection() +
            '-' +
            getGuidSection() +
            '-' +
            getGuidSection() +
            '-' +
            getGuidSection() +
            getGuidSection() +
            getGuidSection()
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/utils/commonjs/guidGenerator.js
// module id = 2451
// module chunks = 62